module.exports = __webpack_public_path__ + "static/media/developersGen_logo.16cc996d.png";